import React, {Component} from 'react'
import {connect} from 'react-redux'
import {ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip} from 'recharts'

class PieChartPanel extends Component {
  render() {
    let colors = this.props.colors;
    if(colors === undefined || colors === null || colors.length === 0)
    {
      colors = ["blue", "orange", "green", "indigo", "purple", "yellow", "red", "pink", "teal", "cyan", "white"];
    }
    let data = this.props.data;
    let total = 0;
    data.forEach(element => {
      total += element.Value;
    });

    return (
      <div >
        <div className="title">{this.props.title}</div>
        <div className="row" >
          <div style={{width: "100%", textAlign: "right", marginRight: "10px"}}>
            Total <span style={{display: "inline-block", minWidth: "40px", textAlign: "right"}}>{total}</span>
          </div>
        </div>
        <div className="row">
          <div className="col-9">
            <ResponsiveContainer width={'100%'} height={160}>
              <PieChart>
                <Tooltip cursor={{stroke: 'none', fill: 'none'}} />
                <Legend
                  layout="vertical"
                  align="right"
                  verticalAlign="top"
                  formatter={(value,entry,i) => <span><span style={{display: "inline-block", minWidth: "100px"}}>{data[i].Key}</span><span style={{display: "inline-block", minWidth: "40px", textAlign: "right"}}>{data[i].Value}</span></span>}
                />
                <Pie
                  data={data}
                  cx={60}
                  cy={60}
                  nameKey="Key"
                  dataKey="Value">
                    {data.map((entry, index) => (<Cell key={index} fill={colors[index % colors.length]} />))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(PieChartPanel)